import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Button from '../../components/common/button'
import Modal from '../../components/common/modal';
import TextField from '../../components/common/textField'

import * as actions from './actions'

import './styles.css'
import { opdbGTM } from '../../utils/pulseUtils';
const actionButtonStyle = { width: 80, height: 30, padding: 0, marginLeft: 5 }

class UserManagement extends React.Component {

  state = {
    phone: '',
    phoneError: '',
    roles: [],
    showAddEditModal: false,
    showDeleteConfirmation: false,
  };

  componentDidMount() {
    this.props.getUserList();
    this.roles = (JSON.parse(localStorage.getItem('operator-details')) || {}).master_roles || [];
    this.roles = this.roles.filter(el => el !== 'admin');
    opdbGTM.tabClicked('od_user_management_tab_clicked')
  }

  closeAddEditUserModal = () => {
    this.setState({ showAddEditModal: false, userId: '', phone: '', roles: [], });
    this.props.clearPrevUserDetails();
  }

  onAddUserClick = () => {
    this.setState({
      showAddEditModal: true,
      userId: null,
    })
  }

  onEditClick = (userId, phone) => {
    this.props.searchUser({ phone }, () => {
      this.setState({
        showAddEditModal: true,
        userId: userId
      })
    })
  }

  onToggleUserStateClick = (userId, isActive) => {
    this.props.updateUserState(userId, { status: !isActive });
  }

  onChange = (value) => {
    if(+value < 0 || +value.length > 10) return;
    this.setState({ phone: value })
  }

  onClickRoles = (e) => {
    const { checked, name } = e.target;
    this.setState(prevState => ({
      roles: checked? prevState.roles.concat(name): prevState.roles.filter(el => el !== name)
    }))
  }

  onSearchUserClick = () => this.props.searchUser({ phone: this.state.phone })

  onUpdateRoleClick = () => {
    const { roles } = this.state;
    const { userDetails } = this.props;
    if(this.state.userId)
      this.props.updateUserRoles(userDetails.userId, { roles }, () => {
        this.closeAddEditUserModal();
        // fetch the user list again
        this.props.getUserList();
      });
    else
      this.props.addUser({ phone_number: this.state.phone, roles }, () => {
        this.closeAddEditUserModal();
        // fetch the user list again
        this.props.getUserList();
      });
  }

  onOpenDeleteConfirmationModal = (userId) => {
    this.setState({
      showDeleteConfirmation: true,
      userId,
    })
  }

  onCloseDeleteConfirmationModal = () => {
    this.setState({
      showDeleteConfirmation: false,
      userId: '',
    })
  }

  onDeleteUserClick = () => {
    this.props.deleteUser(this.state.userId, () => {
      this.onCloseDeleteConfirmationModal();
      // fetch the user list again
      this.props.getUserList();
    });
  }

  render() {
    const { phone, roles } = this.state;
    const { userDetails, userList } = this.props;
    return (
      <div className="manage-user-wrp">
        <div className="row payout-header">
          <span className="payout-header-text">Manage User</span>
          <div className="add-user-button">
            <Button label="Add User" onButtonClick={this.onAddUserClick} />
          </div>
        </div>
        <div className="row user-table-content">
          <table className="app-table">
            <thead>
              <tr className="user-list-table-header">
                <th>No</th>
                <th>User Name</th>
                <th>Phone Number</th>
                <th>Roles</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {
                !userList.length && <tr><td colSpan={7} className="table-no-data">No Data Found</td></tr>
              }
              {
                userList.map((el, i) => (
                  <tr key={i} className="user-list-table-row">
                    <td>{i+1}</td>
                    <td>{el.user_name}</td>
                    <td>{el.phone_number}</td>
                    <td>{el.roles? el.roles.join(', ') : '-'}</td>
                    <td>
                      <Button styleObj={actionButtonStyle} label="Edit" onButtonClick={this.onEditClick.bind(this, el.user_id, el.phone_number)} />
                      <Button styleObj={actionButtonStyle} label={el.is_active? "Disable": "Enable"} onButtonClick={this.onToggleUserStateClick.bind(this, el.user_id, el.is_active)} />
                      <Button styleObj={actionButtonStyle} label="Delete" onButtonClick={this.onOpenDeleteConfirmationModal.bind(this, el.user_id)} />
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        {
          this.state.showAddEditModal &&
            <Modal classes="add-user-modal-wrp" overlay>
              <a href="javascript:void(0)" title="Close" className="closeLoginModal" onClick={this.closeAddEditUserModal}>X</a>
              <p className="payout-header-text">{this.state.userId? 'Edit': 'Add'} User Form</p>
              {!this.state.userId && 
                <div className="add-user-search">
                  <TextField errorMsg={this.state.phoneError} withClear type="number" value={phone} onChange={this.onChange} placeholder="Mobile Number" />
                  <Button styleObj={actionButtonStyle} label="Search" onButtonClick={this.onSearchUserClick} />
                </div>
              }
              {userDetails.error &&
                <p className="app-error no-user-error">{userDetails.error}</p>
              }
              {!userDetails.error && userDetails.userId &&
                <div className="user-details-wrp">
                  <p style={{ paddingBottom: 12 }}><b>User Details:-</b></p>
                  <table className="user-detail-table">
                    <tbody className="">
                      <tr>
                        <td className="">User Id-</td>
                        <td className="">{userDetails.userId}</td>
                      </tr>
                      <tr>
                        <td className="">User Name-</td>
                        <td className="">{userDetails.name}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ marginTop: 15 }}>
                    <p>Roles:</p>
                    {
                      this.roles.map(el => (
                        <div key={el}>
                          <input type="checkbox" id={el} name={el} checked={roles.includes(el)} onChange={this.onClickRoles} />
                          <label className="roles-label" htmlFor={el}>{el}</label>
                        </div>
                      ))
                    }
                    {/*
                    <div>
                      <input type="checkbox" id="admin" name="admin" checked={roles.includes('admin')} onChange={this.onClickRoles} />
                      <label className="roles-label" htmlFor="admin">Admin</label>
                    </div>
                    <div>
                      <input type="checkbox" id="staff" name="staff" checked={roles.includes('staff')} onChange={this.onClickRoles} />
                      <label className="roles-label" htmlFor="staff">Staff</label>
                    </div>
                    <div>
                      <input type="checkbox" id="supervisor" name="supervisor" checked={roles.includes('supervisor')} onChange={this.onClickRoles} />
                      <label className="roles-label" htmlFor="supervisor">Supervisor</label>
                    </div>
                    <div>
                      <input type="checkbox" id="accountant" name="accountant" checked={roles.includes('accountant')} onChange={this.onClickRoles} />
                      <label className="roles-label" htmlFor="accountant">Accountant</label>
                    </div>
                    <div>
                      <input type="checkbox" id="guest" name="guest" checked={roles.includes('guest')} onChange={this.onClickRoles} />
                      <label className="roles-label" htmlFor="guest">Guest</label>
                    </div>
                    */}
                    <div className="update-role-button">
                      <Button label={this.state.userId? "Update Roles": "Add Roles"} onButtonClick={this.onUpdateRoleClick} />
                    </div>
                  </div>
                </div>
              }
            </Modal>
        }
        {
          this.state.showDeleteConfirmation &&
            <Modal classes="add-user-modal-wrp delete-modal" overlay>
              <a href="javascript:void(0)" title="Close" className="closeLoginModal" onClick={this.onCloseDeleteConfirmationModal}>X</a>
              <p className="payout-header-text">Are you sure want to delete the user?</p>
              <div className="delete-user-action">
                <Button styleObj={actionButtonStyle} label="Cancel" onButtonClick={this.onCloseDeleteConfirmationModal} />
                <Button styleObj={actionButtonStyle} label="Delete" onButtonClick={this.onDeleteUserClick} />
              </div>
            </Modal>
        }
      </div>
    )
  }
}


const mapStateToProps = store => ({
  userList: store.userManagementReducer.userList,
  userDetails: store.userManagementReducer.userDetails
})

const mapDispatchToProps = dispatch => ({
  getUserList: () => dispatch(actions.getUserList()),
  searchUser: (query, callback) => dispatch(actions.searchUser(query, callback)),
  clearPrevUserDetails: () => dispatch(actions.clearPrevUserDetails()),
  updateUserState: (userId, query) => dispatch(actions.updateUserState(userId, query)),
  updateUserRoles: (userId, data, callback) => dispatch(actions.updateUserRoles(userId, data, callback)),
  deleteUser: (userId, callback) => dispatch(actions.deleteUser(userId, callback)),
  addUser: (data, callback) => dispatch(actions.addUser(data, callback))
})

UserManagement.propTypes = {
  userList: PropTypes.array.isRequired,
  getUserList: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement)
